<style lang="scss" scoped>
    .tit-span{
        color: #64BDE0;
    }
</style>
<template>
    <div name="mask-title" class="overHidden m-b-10 tool-box" style="padding-left: 60px;">
        <span class="tit-span displayIB font16 textRight">{{txt}}</span>
    </div>
</template>
<script>
    export default {
        name: 'mask-title',
        props: {
            txt:{
                default:'--'
            }
        },
        data() {
            return {};
        },
        mounted() {

        },
        methods: {},
        components: {}
    };
</script>


// WEBPACK FOOTER //
// src/components/mask-title.vue